function emailValidation() {
    var component = {
            input: $('input[name="email"]'),
            message: {
                field: $('.mail'),
                success: $('.valid'),
                error: $('.error')
            }
        },
        regex = /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;

  component.input.blur(function () {
    regex.test(component.input.val()) ? component.message.field.removeClass('valid').addClass('error') : component.message.field.removeClass('error').addClass('error');
  });

    component.input.keydown(function () {
        var submit = $(this).closest('form').find('[type="submit"]');
        console.log( submit );
        if (regex.test(component.input.val())) {
            if ( submit.attr('disabled') ) {
                submit.removeAttr('disabled');
                component.message.field.removeClass('error').addClass('valid');
            }
        } else {
            if ( ! submit.attr('disabled') ) {
                submit.attr('disabled','disabled');
                component.message.field.removeClass('valid').addClass('error');
            }
        }
    });
}
